import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import { aliases, md } from 'vuetify/iconsets/md'

const colors = {
  primary: process.env.VUE_APP_COLOR_PRIMARY,
  secondary: process.env.VUE_APP_COLOR_SECONDARY,
  accent: process.env.VUE_APP_COLOR_ACCENT,
  error: process.env.VUE_APP_COLOR_ERROR,
  info: process.env.VUE_APP_COLOR_INFO,
  success: process.env.VUE_APP_COLOR_SUCCESS,
  warning: process.env.VUE_APP_COLOR_WARNING
}

console.log(`colors: ${JSON.stringify(colors)}`)

export default createVuetify({
  icons: {
    defaultSet: 'md',
    aliases,
    sets: { md }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors
      },
      dark: {
        colors
      }
    }
  }
})
